import React from "react";
import ProfileTemplate from "../components/template/ProfileTemplate";
function Profile() {
  return (
    <>
      <ProfileTemplate />
    </>
  );
}

export default Profile;
